export var FinancialBotEnum;
(function (FinancialBotEnum) {
    FinancialBotEnum["COLLECTING"] = "COLLECTING";
    FinancialBotEnum["REBALANCING"] = "REBALANCING";
    FinancialBotEnum["GAS_STATION"] = "GAS_STATION";
})(FinancialBotEnum || (FinancialBotEnum = {}));
//# sourceMappingURL=financial-bot.enum.js.map